import './home.less'

import m from 'mithril'
import Layout from 'views/layout'
import Container from 'views/layout/container'
import Title from 'views/layout/title'
import Event, {EventType} from 'views/partials/events/event'
import {EventDateType} from 'views/partials/events/eventimage'
import EventsContainer from 'views/partials/events/eventscontainer'
import Article, {ArticleType} from 'views/partials/features/articlelink'
import ArticlesContainer from 'views/partials/features/articlescontainer'
import {PublicationType} from 'views/partials/features/publicationlink'
import PublicationsContainer from 'views/partials/features/publicationscontainer'
import IntroBar from 'views/partials/introbar'

export type HighlightType = {
	title: string
}

export default class Home extends Layout<{
	highlight?: HighlightType
	related: {
		articles: Array<ArticleType>
		publications: Array<PublicationType>
	}
	featured_articles: Array<ArticleType>
	featured_publication: PublicationType
	lists: any
	events: Array<EventType>
}> {
	view() {
		const {
			title,
			related,
			featured_articles,
			featured_publication,
			lists,
			events,
			channel
		} = this.attrs.data
		const allTags = lists.tags
		return m('.home', [
			m(Container, [
				m(ArticlesContainer, {related, featured_articles, channel}),
				m(PublicationsContainer, {
					related,
					allTags,
					featured_publication,
					channel
				}),
				m(EventsContainer, {events, lists})
			])
		])
	}
}
